// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"2025c3ef","73":"bdc0f546","135":"7f82049e","185":"63310be0","293":"43b04b36","403":"82b80b06","518":"f52fe655","527":"07b84dd8","535":"3dd0c1a7","565":"c53b70a5","591":"664583c6","683":"5d9f0530","768":"7f4c923f","787":"4c1c003a","804":"65592b92","986":"23367e42"}[chunkId] + ".chunk.js";
};